import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';

const faqs = [
    {
        question: "Is NoteSpace really free?",
        answer: "Yes, our core plan is free forever for individuals. This includes unlimited boards, basic AI usage, and all core note-taking features."
    },
    {
        question: "How does the Smart View AI work?",
        answer: "Smart View uses Google's Gemini models to analyze the text, images, and documents on your current board. It can answer questions, summarize content, and generate study materials based ONLY on your provided context."
    },
    {
        question: "Can I collaborate with others?",
        answer: "Absolutely. You can share boards via a simple link or invite members to your workspace. Changes sync in real-time, and you can see collaborators' cursors."
    },
    {
        question: "Is my data private?",
        answer: "We prioritize privacy. Your notes are stored securely, and AI processing is done ephemerally for Smart View requests. We do not train models on your private data."
    },
    {
        question: "Can I export my notes?",
        answer: "Yes, you can export your boards as PDF, PNG images, or Markdown files. You can also copy structured JSON data if needed."
    }
];

export const FAQSection: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    return (
        <section id="faq" className="faq-section">
            <div className="text-center mb-16">
                <h2 className="section-title">Frequently Asked Questions</h2>
                <p className="text-slate-400">Everything you need to know about NoteSpace.</p>
            </div>

            <div className="max-w-2xl mx-auto">
                {faqs.map((faq, idx) => (
                    <div key={idx} className="faq-item">
                        <button
                            className="faq-trigger"
                            onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                            aria-expanded={openIndex === idx}
                        >
                            <h3 className={`text-base font-bold ${openIndex === idx ? "text-blue-400" : "text-white"} transition-colors`}>
                                {faq.question}
                            </h3>
                            {openIndex === idx ? (
                                <Minus className="w-5 h-5 text-blue-400 flex-shrink-0" />
                            ) : (
                                <Plus className="w-5 h-5 text-slate-500 group-hover:text-white transition-colors flex-shrink-0" />
                            )}
                        </button>

                        <AnimatePresence>
                            {openIndex === idx && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="overflow-hidden"
                                >
                                    <p className="faq-answer">
                                        {faq.answer}
                                    </p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                ))}
            </div>
        </section>
    );
};
